import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/branch_emails.jpg")